// extracted by mini-css-extract-plugin
module.exports = {"row":"ua_row__GpkV9","cell":"ua_cell__Izcng","ico":"ua_ico__C6m0p","step_header":"ua_step_header__W_fRU","step_text":"ua_step_text__xtrlh","num":"ua_num__5ePQt"};